import { FontCategory } from '@quicktools/shared-components/data/fonts';

import { CATEGORIES, RECENT_CATEGORY } from '../../constants';

const EXCLUDED_CATEGORIES = [FontCategory.Wrappers, FontCategory.Codes, FontCategory.Basic];

export default function getCurrentCategories(
  selectedCategory: FontCategory,
  showRecentsCategory: boolean,
) {
  const selected =
    selectedCategory === FontCategory.Recents ? RECENT_CATEGORY : CATEGORIES[selectedCategory];
  let all = Object.values(CATEGORIES).filter(({ id }) => !EXCLUDED_CATEGORIES.includes(id));

  if (showRecentsCategory) {
    all = [RECENT_CATEGORY, ...all];
  }

  const res = [all.sort((a, b) => a.order - b.order), selected] as const;

  return res;
}
